$(document).ready(function(){
  
  $("#AddToCart-product-template").hide();
  
//   $("body").on('click','#AddToCart-product-template-new',function(e){

//     e.preventDefault();
     
//     var selectClone = $("#ProductSelect-product-template").clone().attr("id","ProductSelect-product-template-new");
//     $("#ProductSelect-product-template").after(selectClone);
//     $("#ProductSelect-product-template-new").attr("name","items[1][id]").val();
   
//     var file= $("#Quantity").clone().attr("id","Quantity-new");
//     $("#Quantity").after(file);
//     $("#Quantity-new").attr("name","items[1][properties[quantity]]");
    
//     $(this).parents('form').submit();
//     $("#AddToCart-product-template").trigger("click");

//   });
  
  
//   $("#AddToCart-product-template-new").click(function(e){
//     e.preventDefault();
//     var time = 0;
//     $(".variantList").each(function(index,value){
//       var variantId = $(this).find('input[type=hidden]').val();
//       var quantity = $(this).find('#QuantityNew').val();
//       time += 7000;
//       setTimeout(function(){
//         console.log(variantId);
//         $("#ProductSelect-product-template").val(variantId).trigger("change");
//         $("#Quantity").val(quantity);
//          setTimeout(function(){
//         	$("#AddToCart-product-template").trigger("click");
//          },300);
//       },time);
//     });
    
//   });
  
  
  $('.add').click(function () {
		//if ($(this).prev().val() < 3) {
    	$(this).prev().val(+$(this).prev().val() + 1);
		//}
  });
  $('.sub').click(function () {
    if ($(this).next().val() > 0) {
      if ($(this).next().val() > 0) $(this).next().val(+$(this).next().val() - 1);
    }
  });
  
  
  $("#AddToCart-product-template-new").click(function(e){
    e.preventDefault();
    
    
    
    $(".variantList").each(function(index,value){
      var variantId = $(this).find('input[type=hidden]').val();
      var quantity = $(this).find('#QuantityNew').val();
      if(quantity>0){
        $("#ProductSelect-product-template").val(variantId).trigger("change");
        $("#Quantity").val(quantity);
        console.log(variantId);
        return false;
      }
    });
    
    var items = [];
    var shiftFirst=false;
    $("#AddToCart-product-template").trigger("click");
    var clr = setInterval(function(){ 
      console.log("true");
      if($(".addtocartbg").length <= 0){
        clearInterval(clr);
        if($(".pplr_red_wrapper").length==0){
          var width = $("body").width();
    	  var height = $("body").outerHeight();
        	$("body").append('<div class="poverlay-bg addtocartbg"><div class="pplr_cont" data-pct="100"><svg class="pplr_svg" width="200" height="200" viewPort="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"><circle r="90" cx="100" cy="100" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0"></circle><circle class="pplr_bar" r="90" cx="100" cy="100" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0" style="stroke-dashoffset: -565.487px;"></circle></svg></div><span class="progress-title">Adding To Cart</span></div>');
        	$(".poverlay-bg").width(width);
            if(height>0){
              $(".poverlay-bg").height(height);
            }
            else{ 
              $(".poverlay-bg").css("position", 'fixed'); 
            }
          $(".poverlay-bg").fadeIn();
        }
        $.getJSON('/cart.js', function(cart) {
         // now have access to Shopify cart object
         var properties = cart.items[0].properties;
        $(".variantList").each(function(index,value){
          
          var variantId = $(this).find('input[type=hidden]').val();
          var quantity = $(this).find('#QuantityNew').val();
          if(quantity>0){
          if(shiftFirst){
          items.push({
            'id' : variantId,
			'quantity' : quantity,
            'properties' : properties
          });
          }
          else{
          shiftFirst = true;
          }
          }
        });
         console.log(items.length);
         if(items.length){
           $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
             items: items
            },
             dataType: 'json', 
             success: function (data) {
               console.log("true");
               $(".addtocartbg").remove();
                window.location.href ='/cart';
             },
              error: function(data, errorThrown)
              {
                   window.location.href ='/cart';
              }
            });
         }
         else{
           $(".addtocartbg").remove();
         }
       });
	
        
      }
    }, 100);
  });


  /* cart page */

  $('.template-cart .js-qty__adjust').click(function(){
      var form = $(this).parents('form');    
      setTimeout(function(){ form.submit() }, 1000);
  });
 
  
});